export default __webpack_public_path__ + "static/happiness-71fb93ca39c1d447e271f428a7bf7c8c.png";